@if(state && state !== 'postNow'){<p class="text-center text-secondary fs-5">{{'poll_creation.preview' | translate}}</p>}
@if(poll){
    <div class="preview-item">
        @if(state && state !== 'choose'){
            <p class="text-secondary text-center pt-1 pb-2">
                @if(author){
                    {{author}} {{'add_other_feedback.poll.posted' | translate}} 
                }@else{
                    {{'add_other_feedback.poll.posted_alt' | translate}}
                }
            </p>
        }
        <div class="border rounded bg-white">
            <div class="card-top p-0"></div>
            <div class="px-4 pt-3 pb-3">
                @switch (previewType) {
                    @case ('AgreeDisagreeQuestion') {
                        <agree-disagree-question [question]="poll"></agree-disagree-question>
                    }
                    @case ('ScaleQuestion') {
                        <scale-question [question]="poll"></scale-question>
                    }
                    @case ('FiveStarsQuestion') {
                        <five-stars-question [question]="poll"></five-stars-question>
                    }
                    @case ('ClosedQuestion') {
                        <closed-question [question]="poll"></closed-question>
                    }
                  }
            </div>
        </div>
    </div>
    @if(state && state !== 'choose' && allowComments){
        <div class="preview-item">
            <allow-comments-preview [allowComments]="allowComments"></allow-comments-preview>
        </div>
    }
    @if(state === 'schedule' || state === 'target' || state === 'publish' || state === 'postNow'){
        <div class="preview-item">
            <target-preview [selectedTeams]="selectedTeams"></target-preview>
        </div>
    }
    @if(state === 'schedule' || state === 'publish' || state === 'postNow'){
        <div class="preview-item">
            <schedule-preview [options]="options"></schedule-preview>
        </div>
    }
    @if(state === 'schedule' || state === 'publish'){
        <div class="preview-item pt-1">
            <recurrence-preview [recurrence]="recurrence"></recurrence-preview>
        </div>
    }
}@else {
    <div class="preview-item">
        <div class="question-placeholder rounded">
            <div class="card-top p-0"></div>
            <div class="px-4 py-3 pb-2 ">
                <p class="text-center text-secondary fst-italic p-5">
                    {{'poll_creation.preview_select_template' | translate}}
                </p>                        
            </div>
        </div>
    </div>
}